import { APP_ID, ApplicationConfig, importProvidersFrom, inject, PLATFORM_ID } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';

import { APP_ROUTES } from './app.routes';
import {
    HTTP_INTERCEPTORS,
    HttpBackend,
    provideHttpClient,
    withFetch,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { Options, SimpleNotificationsModule } from 'angular2-notifications';
import { ModalModule } from 'ngx-bootstrap/modal';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NameWithDashesPipe } from '@shared/pipes/name-with-dashes.pipe';
import { TrimPipe } from '@shared/pipes/trim.pipe';
import { UiSwitchModule } from 'ngx-ui-switch';
import { Interceptor } from '@shared/services/interceptor.service';
import packageJson from 'package.json';
import { isPlatformServer } from '@angular/common';
import { environment } from '@environment';

function HttpLoaderFactory(httpBackend: HttpBackend) {
    const platformId = inject(PLATFORM_ID);
    const baseUrl = isPlatformServer(platformId) ? environment.faqUrl.slice(0, -1) : '';
    return new MultiTranslateHttpLoader(httpBackend, [
        { prefix: baseUrl + '/assets/i18n/', suffix: '.json?' + packageJson.version },
        { prefix: baseUrl + '/sb-tools/assets/i18n/', suffix: '.json?' + packageJson.version },
        {
            prefix: baseUrl + '/sb-modules/Frontend-Cookie-Law-Banner-Module/assets/i18n/',
            suffix: '.json?' + packageJson.version,
        },
        {
            prefix: baseUrl + '/sb-modules/Frontend-Document-Viewer-Module/assets/i18n/',
            suffix: '.json?' + packageJson.version,
        },
        { prefix: baseUrl + '/sb-modules/Frontend-Footer-Module/assets/i18n/', suffix: '.json?' + packageJson.version },
        {
            prefix: baseUrl + '/sb-modules/Frontend-Settings-Menu-Module/assets/i18n/',
            suffix: '.json?' + packageJson.version,
        },
        {
            prefix: baseUrl + '/sb-modules/Frontend-User-Avatar-Module/assets/i18n/',
            suffix: '.json?' + packageJson.version,
        },
        {
            prefix: baseUrl + '/sb-modules/Frontend-Table-Module/assets/i18n/',
            suffix: '.json?' + packageJson.version,
        },
    ]);
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(APP_ROUTES, withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        importProvidersFrom(
            SimpleNotificationsModule.forRoot({
                position: ['bottom', 'right'],
                timeOut: 3000,
                lastOnBottom: true,
                showProgressBar: true,
                pauseOnHover: true,
            } as Options),
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpBackend],
                },
            }),
            UiSwitchModule.forRoot({
                size: 'small',
                color: '#fed030',
                switchColor: '#FFFFFF',
                defaultBgColor: '#FFFFFF',
                defaultBoColor: '#dfdfdf',
                checkedLabel: '',
                uncheckedLabel: '',
            }),
            ModalModule.forRoot(),
        ),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: Interceptor,
            multi: true,
        },
        { provide: APP_ID, useValue: 'serverApp' },
        NameWithDashesPipe,
        TrimPipe,
        provideAnimations(),
    ],
};
